import React, { createContext, useState, useEffect } from "react";
import Axios from "axios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // 🏢 يصبح true للمدير العام (SUPER_ADMIN) بعد تسجيل الدخول وقبل اختيار الفرع
  const [requiresBranchSelection, setRequiresBranchSelection] = useState(false);

  // تحميل المستخدم عند أول تشغيل (me.php)
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await Axios.get(
          `${process.env.REACT_APP_API_URL}/auth/me.php`,
          { withCredentials: true }
        );
        if (res.data.status === "success") {
          setUser(res.data.user);
          setRequiresBranchSelection(!!res.data.requiresBranchSelection);
        } else {
          setUser(null);
          setRequiresBranchSelection(false);
        }
      } catch (err) {
        setUser(null);
        setRequiresBranchSelection(false);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // تسجيل الدخول
  const login = async (email, password) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login.php`,
        { email, password },
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setUser(res.data.user);
        const needsBranch = !!res.data.requiresBranchSelection;
        setRequiresBranchSelection(needsBranch);

        // ✅ اختياري: تخزين بيانات المستخدم مؤقتًا
        localStorage.setItem("user", JSON.stringify(res.data.user));

        return {
          success: true,
          user: res.data.user,
          requiresBranchSelection: needsBranch,
        };
      } else {
        return { success: false, message: res.data.message };
      }
    } catch (err) {
      console.error("Login error:", err);
      return {
        success: false,
        message: err.response?.data?.message || "حدث خطأ في الاتصال بالسيرفر",
      };
    }
  };

  // 🏢 اختيار الفرع (خاص بالمدير العام فقط، مرة واحدة بعد الدخول)
  const selectBranch = async (branchId) => {
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/auth/selectBranch.php`,
        { branch_id: branchId },
        { withCredentials: true }
      );

      if (res.data.status === "success") {
        setUser((prev) => ({
          ...(prev || {}),
          activeBranchId: res.data.activeBranchId,
          activeBranchName: res.data.activeBranchName,
          activeBranch: res.data.activeBranch,
        }));
        setRequiresBranchSelection(false);
        return { success: true };
      }
      return { success: false, message: res.data.message };
    } catch (err) {
      console.error("selectBranch error:", err);
      return {
        success: false,
        message: err.response?.data?.message || "تعذّر اختيار الفرع",
      };
    }
  };

  // تسجيل الخروج
  const logout = async () => {
    try {
      await Axios.post(`${process.env.REACT_APP_API_URL}/auth/logout.php`, {});
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setUser(null);
      setRequiresBranchSelection(false);
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        requiresBranchSelection,
        login,
        selectBranch,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
